module.exports = __webpack_public_path__ + "img/card-f-dim.6cd0cc2e.png";